import { useState } from "react";
import styles from "./IncomeProductsTab.module.css";
import CustomSelect from '../../customComponents/CustomSelect';
import { FaMoneyBillWave, FaChartLine, FaShoppingCart, FaCog } from "react-icons/fa";

const IncomeProductsTab = () => {
  const [Select, setSelect] = useState('');
    const [selectedDate, setSelectedDate] = useState(
      new Date().toISOString().split("T")[0]
    );
  
    return (
      <div className={styles.container}>
        {/* Верхние карточки */}
        <div className={styles.stats}>
          <div className={`${styles.card} ${styles.blue}`}>
            <div className={styles.cardIcon}>
              <FaMoneyBillWave />
            </div>
            <div>
              <p>Выручка</p>
              <h3>0 ₸</h3>
            </div>
          </div>
  
          <div className={`${styles.card} ${styles.green}`}>
            <div className={styles.cardIcon}>
              <FaChartLine />
            </div>
            <div>
              <p>Чистая прибыль</p>
              <h3>0 ₸</h3>
            </div>
          </div>
  
          <div className={`${styles.card} ${styles.gray}`}>
            <div className={styles.cardIcon}>
              <FaShoppingCart />
            </div>
            <div>
              <p>Количество продаж</p>
              <h3>0 шт</h3>
            </div>
          </div>
        </div>
  
        {/* Фильтры */}
        <div className={styles.filters}>
          <CustomSelect
            className={styles.filters__select}
            options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
            value={Select}
            onChange={setSelect}
            placeholder="Select"
          />
          <CustomSelect
            className={styles.filters__select}
            options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
            value={Select}
            onChange={setSelect}
            placeholder="Select"
          />
          <CustomSelect
            className={styles.filters__select}
            options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
            value={Select}
            onChange={setSelect}
            placeholder="Select"
          />
          <input
            type="text"
            placeholder="Наименование товара"
            className={styles.input}
          />
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className={styles.input}
          />
  
          <CustomSelect
            className={styles.filters__select}
            options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
            value={Select}
            onChange={setSelect}
            placeholder="Select"
          />
        </div>
  
        {/* Таблица */}
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Название</th>
                <th>Артикул</th>
                <th>Категория</th>
                <th>Количество продаж</th>
                <th>Прибыль</th>
                <th>Остаток</th>
                <th>
                  <FaCog />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="7" className={styles.emptyText}>
                  Здесь пусто
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

export default IncomeProductsTab;
